import uuid from 'uuid/v4';

import { FULFILLMENT_METHOD_COLLECTION, HOME_MAP_DEFAULT_RADIUS } from '../utils/constants';
import {
  getFulfillmentTime,
  getLatLon,
  getSearchQuery,
  buildSelectedFilters,
} from './homeSelectors';

export const getIsHomeMapOpen = ({ home }) => home.map.isOpen === true;

/**
 * Turns the selected filters from
 *   ["filterA=value1", "filterB=value2", "filterA=value3"]
 * into
 *   [
 *     {id: "filterA", value: ["value1", "value3"]},
 *     {id: "filterB", value: ["value2"]}
 *   ]
 */
export const getOptionsParams = (state) => {
  const selectedParams = buildSelectedFilters(state)
    .map((filter) => filter.split('='))
    // The sort filter is forced to distance in the backend
    // so we're removing it from the query.
    .filter(([id]) => id !== 'sort')
    .reduce((acc, [id, value]) => {
      acc[id] = acc[id] || [];
      acc[id].push(value);
      return acc;
    }, {});

  return Object.keys(selectedParams).map((id) => ({ id, value: selectedParams[id] }));
};

/**
 * Not using the URL input for this request as it
 * contains location parameters (city and neighbourhood)
 * that cannot be removed and would conflict with the
 * location input parameters.
 */
export const getHomeMapViewQueryOptions = (state) => ({
  location: {
    ...getLatLon(state),
    radius: HOME_MAP_DEFAULT_RADIUS,
  },
  options: {
    delivery_time: getFulfillmentTime(state),
    // Forcing the fulfillment method to COLLECTION since
    // the map view is only for COLLECTION orders.
    fulfillment_method: FULFILLMENT_METHOD_COLLECTION,
    params: getOptionsParams(state),
    query: getSearchQuery(state),
  },
  uuid: uuid(),
});

export const getIsHomeMapLoading = ({ home }) => home.map.isLoading === true;
export const getHomeMapCards = ({ home }) => home.map.cards;
export const getHomeMapHasError = ({ home }) => home.map.hasError;
export const getHomeMapLatLngBounds = ({ home }) => home.map.latLngBounds;
export const getHomeMapPins = ({ home }) => home.map.pins;
export const getHomeMapSelectedRestaurantId = ({ home }) => home.map.selectedRestaurantId;
